import {
  DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_BEGIN,
  DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_SUCCESS,
  DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_FAILURE,
  DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function getDatabasesForAppwrite(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/appwrites/get-database`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          console.log('err.response :>> ', err);
          toast.error(`Failed: Please Check your Credentials !`, {});
          dispatch({
            type: DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetDatabasesForAppwriteError() {
  return {
    type: DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_BEGIN:
      return {
        ...state,
        getDatabasesForAppwritePending: true,
        getDatabasesForAppwriteError: null,
      };

    case DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_SUCCESS:
      return {
        ...state,
        getDatabasesForAppwritePending: false,
        getDatabasesForAppwriteError: null,
        databaseByAppwrite: action.data,
      };

    case DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_FAILURE:
      return {
        ...state,
        getDatabasesForAppwritePending: false,
        getDatabasesForAppwriteError: action.data.error,
      };

    case DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_DISMISS_ERROR:
      return {
        ...state,
        getDatabasesForAppwriteError: null,
      };

    default:
      return state;
  }
}
